export const VISIBILITY_PUBLIC = 'public';
export const VISIBILITY_PRIVATE = 'private';
export const VISIBILITY_CONFIDENTIAL = 'confidential';

export type VISIBILITY_PUBLIC = typeof VISIBILITY_PUBLIC;
export type VISIBILITY_PRIVATE = typeof VISIBILITY_PRIVATE;
export type VISIBILITY_CONFIDENTIAL = typeof VISIBILITY_CONFIDENTIAL;

export type ScheduleVisibility =
  | VISIBILITY_PUBLIC
  | VISIBILITY_PRIVATE
  | VISIBILITY_CONFIDENTIAL;
